

























































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Step } from '../../mixins';
import { Method } from '../../../core/utils';
import Input from '../../../core/components/Input.vue';

@Component({
    components: {
        Input
    }
})
export default class DescriptionStepper extends Mixins(Step) {
    @Prop() name: string;
    @Prop() loading: boolean;
    @Prop() updateName: Method<string, void>;
    validateForm: boolean = false;

    get nameRules(): any[] {
        return this.validateForm ? [v => !!v || 'valor requerido'] : [];
    }

    handleUpdateName(str: string): void {
        this.updateName(str);
        this.disableValidationForm();
    }

    handleFinish(): void {
        this.validateForm = true;
        this.$nextTick()
            .then(() => this.form.validate())
            .then(valid => {
                if (valid) {
                    this.$_finishStep();
                }
            });
    }

    disableValidationForm(): void {
        this.validateForm = false;
    }

    get form(): HTMLFormElement {
        return this.$refs.form as HTMLFormElement;
    }

    resetValidation() {
        this.disableValidationForm();
        this.form.resetValidation();
    }

    resetForm(): void {
        this.resetValidation();
    }

    handleSubmit(): void {
        this.handleFinish();
    }
}
